import React,{ useState} from 'react'
function IsDefault(props) {
    const [checked, setChecked] = useState(false);
    function getSourcetoTarget(event){
        props.getSourcetoTarget(event.target.checked)
    }

    return (
        <div className="form-check mAuto">
            {
                <input 
                    className="custom-control-input form-check-input" 
                    type="checkbox" 
                    id={"sourcetotarget"} 
                    defaultChecked={checked}
                    onChange={getSourcetoTarget} 
                />
            }
            
            <label className="custom-control-label form-check-label" for={"sourcetotarget"}>
                Is Default ?
            </label>
        </div>
    )
}
export default IsDefault
